module.exports = __webpack_public_path__ + "img/view.f00fe60c.svg";